export default "__VITE_ASSET__BOqVEMkg__"